"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPostSportDigestResponseDto = instanceOfPostSportDigestResponseDto;
exports.PostSportDigestResponseDtoFromJSON = PostSportDigestResponseDtoFromJSON;
exports.PostSportDigestResponseDtoFromJSONTyped = PostSportDigestResponseDtoFromJSONTyped;
exports.PostSportDigestResponseDtoToJSON = PostSportDigestResponseDtoToJSON;
exports.PostSportDigestResponseDtoToJSONTyped = PostSportDigestResponseDtoToJSONTyped;
var PostSportDigestTimeDto_1 = require("./PostSportDigestTimeDto");
var PostSportStreamingPlatformsDto_1 = require("./PostSportStreamingPlatformsDto");
/**
 * Check if a given object implements the PostSportDigestResponseDto interface.
 */
function instanceOfPostSportDigestResponseDto(value) {
    if (!('streamingPlatforms' in value) || value['streamingPlatforms'] === undefined)
        return false;
    if (!('digestTime' in value) || value['digestTime'] === undefined)
        return false;
    return true;
}
function PostSportDigestResponseDtoFromJSON(json) {
    return PostSportDigestResponseDtoFromJSONTyped(json, false);
}
function PostSportDigestResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'streamingPlatforms': (0, PostSportStreamingPlatformsDto_1.PostSportStreamingPlatformsDtoFromJSON)(json['streamingPlatforms']),
        'digestTime': (0, PostSportDigestTimeDto_1.PostSportDigestTimeDtoFromJSON)(json['digestTime']),
    };
}
function PostSportDigestResponseDtoToJSON(json) {
    return PostSportDigestResponseDtoToJSONTyped(json, false);
}
function PostSportDigestResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'streamingPlatforms': (0, PostSportStreamingPlatformsDto_1.PostSportStreamingPlatformsDtoToJSON)(value['streamingPlatforms']),
        'digestTime': (0, PostSportDigestTimeDto_1.PostSportDigestTimeDtoToJSON)(value['digestTime']),
    };
}
